import * as React from "react";

;
export const Plus = (props: React.SVGProps<SVGSVGElement>) => <svg xmlns="http://www.w3.org/2000/svg" width={24} height={24} fill="none" {...props}><path fill="#100722" d="M11.25 12.75V22h1.5v-9.25H22v-1.5h-9.25V2h-1.5v9.25H2v1.5h9.25Z" /></svg>;